import React from "react";
import "./dashboardToolbar.scss";
import MaterialToolbar from "@mui/material/Toolbar";
import { JameoLogo } from "../JameoLogo";
import styles from "./dashboardToolbar.module.scss";
import { useTranslation } from "react-i18next";
import classNames from "classnames";
import { Link } from "react-router-dom";
import { ROUTES } from "../../utils/Constant";

import ShoppingCartOutlinedIcon from "@mui/icons-material/ShoppingCartOutlined";
//import NotificationsNoneOutlined from "@mui/icons-material/NotificationsNoneOutlined";
import IconButtonForButtonGroup from "../../common/components/IconButtonForButtonGroup";
import ProfileMenu from "../../components/ProfileMenu";
//import { ReactComponent as SparklingIcon } from "./../../assets/images/sparkling.svg";
import Avatar from "../../common/components/Avatar";
import { useSelector } from "react-redux";

const DashboardToolbar = (props) => {
  const userInfos = useSelector((state) => state.userInfo);

  const { t } = useTranslation();

  return (
    <React.Fragment>
      <MaterialToolbar className="dashboard-main-header">
        <div className={styles.leftSection}>
          <JameoLogo className={styles.logo} />
        </div>

        <div className={classNames("navbar-right", styles.rightSection)}>
          <ul className="right-socialbar">
            <li className="icon">
              <Link to={ROUTES.CART}>
                <IconButtonForButtonGroup
                  className={styles.iconButtonRoot}
                  toolTipTitle={t("dashboard_toolbar.mycart")}
                >
                  <ShoppingCartOutlinedIcon className={styles.iconRoot} />
                </IconButtonForButtonGroup>
              </Link>
            </li>
            <li className="menu">
              <ProfileMenu
                menuIcon="ExpandMore"
                isAdmin={userInfos.isAdmin || userInfos.isDesigner}
              >
                <div className={styles.dropdown}>
                  {userInfos?.firstName ? (
                    <Avatar
                      imageUrl={userInfos.imageUrl}
                      initials={userInfos.firstName[0]}
                    />
                  ) : null}
                </div>
              </ProfileMenu>
            </li>
          </ul>
        </div>
      </MaterialToolbar>
    </React.Fragment>
  );
};
export default DashboardToolbar;
